<template>
    <div class="modal-box" v-loading="loading">
        <div class="modal-box-inner with-title">
            <div class="modal-box-header-inner" v-if="this.header">
                <span v-if="typeof this.data.user !== 'undefined'" class="modal-box-header-title">
                    edit user
                </span>
                <span v-else class="modal-box-header-title">
                    add new user
                </span>
            </div>
            <div class="modal-box-content add-user">

              <div class="modal-box-content-form-desktop">
                <el-form ref="formDesktop" :rules="rules" :model="form" @submit.prevent.native="formSubmit('formDesktop')">
                  <div class="modal-box-content-form-row">
                    <div class="modal-box-content-form-column">
                      <el-form-item prop="first_name">
                        <el-input ref="first_name" v-model="form.first_name" placeholder="first name" tabindex="1"></el-input>
                      </el-form-item>
                      <el-form-item prop="password">
                        <el-input v-model="form.password" type="password" placeholder="password" tabindex="3"></el-input>
                      </el-form-item>
                      <el-form-item prop="email" class="margin-bottom-extended">
                        <el-input v-model="form.email" ref="email" placeholder="email" tabindex="5"></el-input>
                      </el-form-item>
                    </div>
                    <div class="modal-box-content-form-column">
                      <el-form-item prop="last_name">
                        <el-input ref="last_name" v-model="form.last_name" placeholder="last name" tabindex="2"></el-input>
                      </el-form-item>

                      <el-form-item prop="password_confirmation">
                        <el-input v-model="form.password_confirmation" type="password" placeholder="password confirmation" tabindex="4"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="modal-box-content-form-row selects">
                    <div class="modal-box-content-form-column">
                      <el-form-item>
                        <span class="el-select-label">user group/ permissions</span>
                        <el-select v-model="form.role" placeholder="select" tabindex="6">
                          <el-option
                            v-for="item in roles"
                            :key="item"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="modal-box-content-form-column">
                      <el-form-item>
                        <span class="el-select-label">department/ access</span>
                        <el-select v-model="form.department" placeholder="select" tabindex="7">
                          <el-option
                            v-for="item in departments"
                            :key="item"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>

                  <div class="modal-box-actions">
                    <button native-type="submit" type="primary" class="modal-box-actions-item button" tabindex="8">Save</button>

                    <button native-type="button" @click.prevent="close" type="text" class="modal-box-actions-item button white">Cancel</button>
                  </div>

                </el-form>
              </div>

              <div class="modal-box-content-form-mobile">
                <el-form ref="formMobile" :rules="rules" :model="form" @submit.prevent.native="formSubmit('formMobile')">
                  <div class="modal-box-content-form-row">
                    <div class="modal-box-content-form-column">
                      <el-form-item prop="first_name">
                        <el-input ref="first_name" v-model="form.first_name" placeholder="first name"></el-input>
                      </el-form-item>
                    </div>
                    <div class="modal-box-content-form-column">
                      <el-form-item prop="last_name">
                        <el-input ref="last_name" v-model="form.last_name" placeholder="last name"></el-input>
                      </el-form-item>
                    </div>
                  </div>

                  <el-form-item prop="email" class="margin-bottom-extended">
                    <el-input v-model="form.email" ref="email" placeholder="email"></el-input>
                  </el-form-item>

                  <el-form-item prop="password">
                    <el-input v-model="form.password" type="password" placeholder="password"></el-input>
                  </el-form-item>

                  <el-form-item prop="password_confirmation" class="margin-bottom-extended">
                    <el-input v-model="form.password_confirmation" type="password" placeholder="password confirmation"></el-input>
                  </el-form-item>

                  <el-form-item>
                    <span class="el-select-label">user group/ permissions</span>
                    <el-select v-model="form.role" placeholder="select">
                      <el-option
                        v-for="item in roles"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item class="margin-bottom-extended">
                    <span class="el-select-label">department/ access</span>
                    <el-select v-model="form.department" placeholder="select">
                      <el-option
                        v-for="item in departments"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <div class="modal-box-actions">
                    <button native-type="submit" type="primary" class="modal-box-actions-item button">Save</button>

                    <button native-type="button" @click.prevent="close" type="text" class="modal-box-actions-item button white">Cancel</button>
                  </div>

                </el-form>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
import axios from 'axios'
import { EventBus } from '@/services/eventbus'

export default {
  props: {
    header: {
      type: [Boolean, Object]
    },
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  name: 'UserAddModal',
  data () {
    return {
      loading: false,
      form: {
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        password_confirmation: null,
        role: null,
        department: null
      },
      departments: [],
      roles: [],
      promises: []
    }
  },
  computed: {
    rules: function () {
      return {
        email: [
          { required: true, message: 'Please enter users email', trigger: 'blur' },
          { type: 'email', message: 'You have to enter valid email', trigger: 'blur' }
        ],
        password: [
          { message: 'Please enter users password', trigger: 'blur' }
        ],
        password_confirmation: [
          { required: !this.isBlank(this.form.password), message: 'Please enter password confirmation', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (typeof this.data.user !== 'undefined') {
      this.form.first_name = this.data.user.first_name
      this.form.last_name = this.data.user.last_name
      this.form.email = this.data.user.email
      this.form.department = this.data.user.department !== null ? this.data.user.department.name : null
      this.form.role = this.data.user.role.length ? this.data.user.role[0] : null
      this.form.ids = [this.data.user.id]
    }
    this.promises.push(this.loadRoles())
    this.promises.push(this.loadDepartments())
  },
  mounted () {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.close()
      }
    })
    this.loading = true
    const scope = this
    axios.all(this.promises).then(() => {
      scope.loading = false
    })
  },
  methods: {
    loadRoles () {
      return HTTP({
        method: 'GET',
        url: '/api/v1/users/roles',
        crossdomain: true
      }).then(response => {
        if (response.data.data) {
          this.roles = response.data.data
        }
      }).catch(() => {
      })
    },
    loadDepartments () {
      return HTTP({
        method: 'GET',
        url: '/api/v1/departments',
        crossdomain: true
      }).then(response => {
        if (response.data.data) {
          this.departments = response.data.data
        }
      }).catch(() => {
      })
    },
    formSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          HTTP({
            method: typeof this.data.user === 'undefined' ? 'POST' : 'PUT',
            url: '/api/v1/users',
            crossdomain: true,
            data: this.form
          })
            .then(response => {
              this.loading = false
              if (response.data) {
                this.$notify({
                  // title: 'Success',
                  message: typeof this.data.user === 'undefined' ? 'User added' : 'User updated',
                  type: 'success',
                  position: 'bottom-right',
                  duration: 1750
                })
                this.close()
                EventBus.$emit('reload-users')
              }
            })
            .catch(error => {
              this.loading = false
              this.$notify({
                // title: 'Error',
                dangerouslyUseHTMLString: true,
                message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
                type: 'error',
                position: 'bottom-right',
                duration: 1750
              })
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$emit('close')
    },
    isBlank (str) {
      return (!str || /^\s*$/.test(str))
    }
  }
}
</script>
